/**
 * フォームのバリデーション
 */

export default class Tab {
  constructor(_parm) {
    this.form = document.querySelector(_parm.form);
    if (!this.form) return;
    this.inputs = [...this.form.querySelectorAll('[aria-required="true"]')];
    this.submitButton = this.form.querySelector('button, input[type="submit"]');
    this.errorClass = 'is-error';
    this.errorMessageAttr = 'data-error-message';
    // 言語ごとにエラーメッセージを変えたいので、wpcf7の管理画面上で定義している
    this.errorMessageData = JSON.parse(document.querySelector('#js-form-error-data').textContent);
  }

  /**
   * 1つのinput要素に対してエラー処理を実行（クラス付与やメッセージ表示）
   * @param {Element} input input要素
   * @param {String} message エラーメッセージ
   */
  setError(input, message) {
    // inputに紐づくエラーメッセージ要素を取得
    const elmErrorMessage = this.form.querySelector(`[${this.errorMessageAttr}="${input.name}"]`);
    // エラー処理実行
    elmErrorMessage.textContent = message; // エラーメッセージを表示
    input.classList.add(this.errorClass); // エラークラスを付与
  }

  /**
   * 1つのinput要素に対してバリデーション実行
   * @param {Element} input input要素
   */
  validate(input) {
    // inputに紐づくlabel要素のテキストを取得
    const label = this.form.querySelector(`label[for="${input.name}"]`);
    const labelText = label ? label.textContent : '';

    // inputに紐づくエラーメッセージ要素を取得
    const elmErrorMessage = this.form.querySelector(`[${this.errorMessageAttr}="${input.name}"]`);

    // 最初にエラーリセット
    input.classList.remove(this.errorClass);
    elmErrorMessage.textContent = '';

    // ここから各バリデーションチェックをしていく
    // エラーがあれば、setError()を実行して処理を終了

    // 確認用メールアドレスチェック（name属性が _confirm で終わっている場合）
    if (input.type === 'email' && input.name.match(/_confirm$/)) {
      const baseMailInput = this.form.querySelector(`[name="${input.name.replace(/_confirm$/, '')}"]`);
      if (input.value !== baseMailInput.value) {
        this.setError(input, this.errorMessageData[input.name].not_equal);
        return;
      }
    }
    // 値を持っているか
    const hasValue = input.value ? true : false;
    if (!hasValue) {
      this.setError(input, this.errorMessageData[input.name].required);
      return;
    }
    // メールアドレスかどうか
    if (input.type === 'email') {
      const isEmail = input.value.match(/.+@.+\..+/) ? true : false;
      if (!isEmail) {
        this.setError(input, this.errorMessageData[input.name].mail);
        return;
      }
    }
    // 電話番号かどうか
    if (input.type === 'tel') {
      const isTel = input.value.match(/^[0-9]{2,4}-?[0-9]{2,4}-?[0-9]{3,4}$/) ? true : false;
      if (!isTel) {
        this.setError(input, this.errorMessageData[input.name].tel);
        return;
      }
    }
    // 数字かどうか
    if (input.type === 'number') {
      const isNumber = input.value.match(/^[0-9]+$/) ? true : false;
      if (!isNumber) {
        this.setError(input, this.errorMessageData[input.name].number);
        return;
      }
    }
  }

  /**
   * エラーの数を返す
   * @returns {Number} エラーの数
   */
  getErrorCount() {
    let errorCount = 0;
    this.inputs.forEach((input) => {
      if (input.classList.contains(this.errorClass)) errorCount++;
    });
    return errorCount;
  }

  addEvent() {
    /**
     * 送信ボタンクリック時
     */
    this.submitButton.addEventListener('click', (ev) => {
      ev.preventDefault();
      // バリデーション
      this.inputs.forEach((input) => {
        this.validate(input);
      });
      // エラーの数を取得して、0個ならフォームを送信
      const nowErrorCount = this.getErrorCount();
      if (nowErrorCount === 0) {
        this.form.submit();
      } else {
        // エラーのinputにフォーカスを当てる
        for (let index = 0; index < this.inputs.length; index++) {
          const input = this.inputs[index];
          if (input.classList.contains(this.errorClass)) {
            input.focus();
            break;
          }
        }
      }
    });
    /**
     * input要素のフォーカスアウト時
     */
    this.inputs.forEach((input) => {
      input.addEventListener('blur', (ev) => {
        this.validate(ev.target);
      });
    });
  }

  init() {
    if (!this.form) return;
    this.addEvent();
  }
}
